import script from "./BannersManager.vue?vue&type=script&setup=true&lang=js"
export * from "./BannersManager.vue?vue&type=script&setup=true&lang=js"

import "./BannersManager.vue?vue&type=style&index=0&id=9f9d6f6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f9d6f6a"]])

export default __exports__